import ContentManagement from "../ContenManagement";
import ContentView from "../components/contentView";
import WechatCollectArticle from "../child/wechatCollectArticle/WechatCollectArticle";

export const contentManagement = [
    {
        path: "/newMedia/contentManagement", //微信榜单
        component: ContentManagement
    },
    {
        path: "/newMedia/contentManagement/viewContent",
        component: ContentView
    },
    {
        path: "/newMedia/contentManagement/weChatCollectArticle",
        component: WechatCollectArticle
    }
];